import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginDataService } from "app/login/login-data.service";

@Injectable()
export class DisableLoginGuard implements CanActivate {

	constructor(private _login: LoginDataService) {

	}
	canActivate() {
		console.log("disableLogin", this._login.toggleLoginRoute)
		return !this._login.toggleLoginRoute
	}
}
